import styles from './ComponenetForm.module.css'
import React, { ChangeEvent } from 'react'
import { Component } from '../ListComponents'
import { CustomTextField } from '../CustomTextField'
import { ComponentFile } from '../../context/ComponentBriefingContextProvider'

import { Box, Button, IconButton } from "@mui/material"
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone'
import CloseIcon from '@mui/icons-material/Close'
import SaveIcon from '@mui/icons-material/Save';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import { truncateString } from '@/utils/truncateString'
import { ButtonOpenModalDeleteComponent } from '../ButtonOpenModalDeleteComponent/ButtonOpenModalDeleteComponent'
import PlaylistAddCircleIcon from '@mui/icons-material/PlaylistAddCircle';
import { StyledQuill } from '../Proposta/quill'
import DOMPurify from 'dompurify'

interface ComponentFormProps {
    item: Component;
    isEditing: boolean;
    isIdEditing?: number;
    titulo: string;
    texto: string;
    fileURLs: string[];
    files: File[],
    imageURLs: string[],
    audios: File[],
    audioURLs: string[],
    handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
    handleDeleteComponent: (idComponent: number) => void;
    handleChangeTitle: (event: ChangeEvent<HTMLInputElement>) => void;
    handleChangeText: (e : string) => void;
    handleChangeEditComponent: (idComponent: number) => void;
    handleChangeFile: (event: ChangeEvent<HTMLInputElement>) => void;
    handleDeleteFile: (idFile: number) => void;
    handleOpenFile: (idComponent: number) => void;
    listFile: ComponentFile[];
    setText: React.Dispatch<React.SetStateAction<string>>;
}

export function ComponentForm({
    item,
    isEditing,
    isIdEditing,
    titulo,
    texto,
    fileURLs,
    imageURLs,
    files,
    audios,
    audioURLs,
    handleSubmit,
    handleDeleteComponent,
    handleChangeTitle,
    handleChangeText,
    handleChangeEditComponent,
    handleChangeFile,
    handleDeleteFile,
    handleOpenFile,
    listFile,
    setText
}: ComponentFormProps) {

    function renderizarTextoComLinks(text: string) {
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        const parts = text.split(urlRegex);

        return parts.map((part, index) => {
            if (urlRegex.test(part)) {
                // Renderiza o link como <span> com função de abrir a URL
                return (
                    <span
                        className={styles.span_link}
                        key={index}
                        style={{ color: '#0073e6', textDecoration: 'underline', cursor: 'pointer' }}
                        onClick={() => window.open(part, '_blank', 'noopener noreferrer')}
                    >
                        {part}
                    </span>
                );
            }
            // Texto comum é exibido normalmente
            return <span key={index}>{part}</span>;
        });
    }

    function handlePasteText(event: React.ClipboardEvent<HTMLInputElement | HTMLTextAreaElement>) {
        event.preventDefault();
    
        const pastedText = event.clipboardData.getData("text");
        const target = event.target as HTMLInputElement | HTMLTextAreaElement;
        const { selectionStart, selectionEnd } = target;
    
        setText((prevText) => {
            if (selectionStart !== null && selectionEnd !== null) {
                return (
                    prevText.slice(0, selectionStart) +
                    pastedText +
                    prevText.slice(selectionEnd)
                );
            }
            return prevText + pastedText;
        });
    }

    return (
        <form onSubmit={handleSubmit} className={styles.form_container}>
            {(isIdEditing === item.id) && isEditing ? (
                <>
                    {listFile.length > 0 && item.conteudo === "" ? (
                        <div className={styles.container_update_component_only_imag}>
                            {
                                item.tipoComponente !== 'audio' ? (
                                    <div className={styles.get_component_images}>
                                        {listFile.filter(file => file.componente_id === item.id).map(file => (
                                            <Box position="relative" display="inline-block" key={file.id}>
                                                {
                                                    item.tipoComponente === 'pdf' ? (
                                                        <a href={file.referencia} target='_blank' download={file.nome} className={styles.file_pdf}>
                                                            <PictureAsPdfIcon />
                                                            {truncateString(file.nome, 20)}
                                                        </a>
                                                    ) : item.tipoComponente === 'img' ? (
                                                        <img key={file.id} src={file.referencia} className={styles.image_bucket} onClick={() => handleOpenFile(item.id)} />

                                                    ) : (
                                                        ''
                                                    )
                                                }
                                                <IconButton
                                                    onClick={() => handleDeleteFile(file.id)}
                                                    sx={{
                                                        position: 'absolute',
                                                        top: -8,
                                                        right: -10,
                                                        color: 'white',
                                                        width: 22,
                                                        height: 22,
                                                        background: 'var(--primary-color)',
                                                        '&:hover': {
                                                            background: 'var(--primary-color-light)',
                                                        },
                                                    }}
                                                >
                                                    <CloseIcon style={{ fontSize: '16px' }} />
                                                </IconButton>
                                            </Box>
                                        ))}
                                        {
                                            fileURLs.length > 0 ?
                                                (
                                                    files.map((file, index) => (
                                                        <a href={fileURLs[index]} target='_blanck' type='application/pdf' className={styles.file_pdf}>
                                                            <PictureAsPdfIcon />
                                                            {truncateString(file.name, 12)}
                                                        </a>
                                                    ))
                                                )
                                                : imageURLs.length > 0 ? (
                                                    imageURLs.map((img, index) => (
                                                        <img key={index} src={img} alt="" className={styles.image_bucket} />
                                                    ))
                                                ) : ''
                                        }
                                    </div>
                                ) : (
                                    <div className={styles.editar_lista_componente_audio}>
                                        {listFile.filter(file => file.componente_id === item.id).map(file => (
                                            <div>
                                                <Box position="relative" display="inline-block" key={file.id}>
                                                    <audio controls src={file.referencia} className={styles.audio_player}>
                                                        Seu navegador não suporta o elemento de áudio.
                                                    </audio>

                                                    <IconButton
                                                        onClick={() => handleDeleteFile(file.id)}
                                                        sx={{
                                                            position: 'absolute',
                                                            top: -8,
                                                            right: -10,
                                                            color: 'white',
                                                            width: 22,
                                                            height: 22,
                                                            background: 'var(--primary-color)',
                                                            '&:hover': {
                                                                background: 'var(--primary-color-light)',
                                                            },
                                                        }}
                                                    >
                                                        <CloseIcon style={{ fontSize: '16px' }} />
                                                    </IconButton>
                                                </Box>
                                            </div>
                                        ))}
                                        <div>
                                            {
                                                audioURLs.length > 0 &&
                                                audios.map((audio, index) => (
                                                    <audio controls src={audioURLs[index]} className={styles.audio_player}>
                                                        Seu navegador não suporta o elemento de áudio.
                                                    </audio>
                                                ))
                                            }
                                        </div>
                                    </div>
                                )
                            }

                            <div className={styles.save_delete_or_edit_only_image_component}>
                                <div className={styles.update_component_image}>
                                    <Button
                                        className={styles.button_upload_images}
                                        component="label"
                                        variant="contained"
                                        title={item.tipoComponente === 'img' ? 'Inserir Imagens' : item.tipoComponente === 'pdf' ? 'Inserir PDF' : 'Inserir Áudio'}
                                        style={{ backgroundColor: '#666CFF' }}
                                    >
                                        <>
                                            {
                                                item.tipoComponente === 'img' ? (
                                                    <AddPhotoAlternateIcon fontSize='medium' />
                                                ) : item.tipoComponente === 'audio' ? (
                                                    <PlaylistAddCircleIcon fontSize='medium' />
                                                ) : item.tipoComponente === 'pdf' && (
                                                    <PictureAsPdfIcon fontSize='medium' />
                                                )
                                            }
                                        </>

                                        {
                                            item.tipoComponente === 'img' &&
                                            (
                                                <input
                                                    className={styles.input_fileS}
                                                    type="file"
                                                    accept="image/jpeg, image/png, image/gif"
                                                    hidden
                                                    multiple
                                                    onChange={handleChangeFile}
                                                />
                                            )

                                        }

                                        {
                                            item.tipoComponente === 'pdf' &&
                                            (
                                                <input
                                                    className={styles.input_fileS}
                                                    type="file"
                                                    accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                    hidden
                                                    multiple
                                                    onChange={handleChangeFile}
                                                />
                                            )
                                        }

                                        {
                                            item.tipoComponente === 'audio' &&
                                            (
                                                <input
                                                    id='file-upload'
                                                    type='file'
                                                    accept='audio/*, .mp3, .wav, .ogg'
                                                    hidden
                                                    multiple
                                                    onChange={handleChangeFile}
                                                />
                                            )
                                        }
                                    </Button>
                                </div>
                                <div className={styles.button_save_update}>
                                    <Button
                                        title='Salvar'
                                        type='submit'
                                        variant="contained">
                                        <SaveIcon />
                                    </Button>
                                </div>
                                <div className={styles.button_delete_component}>
                                    <ButtonOpenModalDeleteComponent
                                        handleDeleteComponent={handleDeleteComponent}
                                        id_component={item.id}
                                    />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className={styles.container_update_component}>
                            <div className={styles.container_update_component_row_1}>
                                <div className={styles.container_fields}>
                                    {item.tipoComponente === 'titulo' && (
                                        <CustomTextField
                                            className={styles.title}
                                            label="Título"
                                            placeholder='Insira o título...'
                                            name='titulo'
                                            fullWidth={true}
                                            value={titulo}
                                            onChange={handleChangeTitle}
                                        />
                                    )}
                                    {item.tipoComponente === 'texto' && (
                                        <StyledQuill
                                            theme="snow"
                                            value={DOMPurify.sanitize(texto) ?? ""}
                                            onChange={(e) => {
                                                handleChangeText(e)
                                            }}
                                            style={{ width: '100%' }}
                                            placeholder='Insira o texto aqui...'
                                            />
                                        )}
                                </div>

                                {item.tipoComponente === 'titulo' || item.tipoComponente === 'texto' ? (
                                    <div className={styles.save_delete_or_edit}>
                                        <div className={styles.button_save_update}>
                                            <Button
                                                type='submit'
                                                variant="contained"
                                                title='Salvar'>
                                                <SaveIcon />
                                            </Button>
                                        </div>
                                        <div className={styles.button_delete_component}>
                                            <ButtonOpenModalDeleteComponent
                                                handleDeleteComponent={handleDeleteComponent}
                                                id_component={item.id}
                                            />
                                        </div>
                                    </div>

                                ) :
                                    (
                                        <div className={styles.save_delete_or_edit}>
                                            <div className={styles.update_component_image}>
                                                <Button
                                                    className={styles.button_upload_images}
                                                    component="label"
                                                    variant="contained"
                                                    style={{ backgroundColor: '#666CFF' }}
                                                    title='Inserir Imagens'
                                                >
                                                    <AddPhotoAlternateIcon fontSize='medium' />
                                                    {
                                                        item.tipoComponente === 'img' &&
                                                        (
                                                            <input
                                                                className={styles.input_fileS}
                                                                type="file"
                                                                accept="image/jpeg, image/png, image/gif"
                                                                hidden
                                                                multiple
                                                                onChange={handleChangeFile}
                                                            />
                                                        )

                                                    }

                                                    {
                                                        item.tipoComponente === 'pdf' &&
                                                        (
                                                            <input
                                                                className={styles.input_fileS}
                                                                type="file"
                                                                accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                                hidden
                                                                multiple
                                                                onChange={handleChangeFile}
                                                            />
                                                        )
                                                    }

                                                    {
                                                        item.tipoComponente === 'audio' &&
                                                        (
                                                            <input
                                                                id='file-upload'
                                                                type='file'
                                                                accept='audio/*, .mp3, .wav, .ogg'
                                                                hidden
                                                                multiple
                                                                onChange={handleChangeFile}
                                                            />
                                                        )
                                                    }
                                                </Button>
                                            </div>
                                            <div className={styles.button_save_update}>
                                                <Button
                                                    type='submit'
                                                    variant="contained"
                                                    title='Salvar'>
                                                    <SaveIcon />
                                                </Button>
                                            </div>
                                            <div className={styles.button_delete_component}>
                                                <ButtonOpenModalDeleteComponent
                                                    handleDeleteComponent={handleDeleteComponent}
                                                    id_component={item.id}
                                                />
                                            </div>

                                        </div>
                                    )
                                }

                            </div>

                            {
                                item.tipoComponente !== 'audio' ? (
                                    <div className={styles.get_component_images}>
                                        {listFile.filter(img => img.componente_id === item.id).map(img => (
                                            <Box position="relative" display="inline-block" key={img.id}>
                                                <img src={img.referencia} className={styles.image_bucket} />
                                                <IconButton
                                                    onClick={() => handleDeleteFile(img.id)}
                                                    sx={{
                                                        position: 'absolute',
                                                        top: -8,
                                                        right: -10,
                                                        color: 'white',
                                                        width: 22,
                                                        height: 22,
                                                        background: 'var(--primary-color)',
                                                        '&:hover': {
                                                            background: 'var(--primary-color-light)',
                                                        },
                                                    }}
                                                >
                                                    <CloseIcon style={{ fontSize: '16px' }} />
                                                </IconButton>
                                            </Box>
                                        ))}
                                        {fileURLs.map((img, index) => (
                                            <img key={index} src={img} alt="" />
                                        ))}
                                    </div>
                                ) :
                                    (
                                        <div className={styles.lista_componente_audio}>
                                            {listFile.filter(img => img.componente_id === item.id).map(img => (
                                                <Box position="relative" display="inline-block" key={img.id}>
                                                    <img src={img.referencia} className={styles.image_bucket} />
                                                    <IconButton
                                                        onClick={() => handleDeleteFile(img.id)}
                                                        sx={{
                                                            position: 'absolute',
                                                            top: -8,
                                                            right: -10,
                                                            color: 'white',
                                                            width: 22,
                                                            height: 22,
                                                            background: 'var(--primary-color)',
                                                            '&:hover': {
                                                                background: 'var(--primary-color-light)',
                                                            },
                                                        }}
                                                    >
                                                        <CloseIcon style={{ fontSize: '16px' }} />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                            {fileURLs.map((img, index) => (
                                                <img key={index} src={img} alt="" />
                                            ))}
                                        </div>
                                    )
                            }

                        </div>
                    )}
                </>
            ) : (
                <>
                    {listFile.length > 0 && item.conteudo === "" ? (
                        <div className={styles.component_does_not_update}>
                            {
                                item.tipoComponente !== 'audio' ? (
                                    <>
                                        <div className={styles.get_component_images}>
                                            {listFile.filter(file => file.componente_id === item.id).map(file => (
                                                <React.Fragment key={file.id}>
                                                    {
                                                        item.tipoComponente === 'pdf' ? (
                                                            <a href={file.referencia} target='_blank' download={file.nome} className={styles.file_pdf}>
                                                                <PictureAsPdfIcon />
                                                                {truncateString(file.nome, 20)}
                                                            </a>
                                                        ) : item.tipoComponente === 'audio' ? (
                                                            <audio controls src={file.referencia} className={styles.audio_player}>
                                                                Seu navegador não suporta o elemento de áudio.
                                                            </audio>
                                                        ) : item.tipoComponente === 'img' ? (
                                                            <img key={file.id} src={file.referencia} className={styles.image_bucket} onClick={() => handleOpenFile(item.id)} />

                                                        ) : (
                                                            ''
                                                        )
                                                    }
                                                </React.Fragment>

                                            ))}
                                        </div>
                                        <div className={styles.buttons_edit_component}>
                                            <Button
                                                title='Editar'
                                                variant='contained'
                                                onClick={() => handleChangeEditComponent(item.id)}>
                                                <EditTwoToneIcon />
                                            </Button>
                                            <ButtonOpenModalDeleteComponent
                                                handleDeleteComponent={handleDeleteComponent}
                                                id_component={item.id}
                                            />
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className={styles.lista_componente_audio}>
                                            <div className={styles.itens}>
                                                {listFile.filter(file => file.componente_id === item.id).map(file => (
                                                    <React.Fragment key={file.id}>
                                                        <audio controls src={file.referencia} className={styles.audio_player}>
                                                            Seu navegador não suporta o elemento de áudio.
                                                        </audio>
                                                    </React.Fragment>

                                                ))}
                                            </div>
                                        </div>
                                        <div className={styles.buttons_edit_component}>
                                            <Button
                                                title='Editar'
                                                variant='contained'
                                                onClick={() => handleChangeEditComponent(item.id)}>
                                                <EditTwoToneIcon />
                                            </Button>
                                            <ButtonOpenModalDeleteComponent
                                                handleDeleteComponent={handleDeleteComponent}
                                                id_component={item.id}
                                            />
                                        </div>
                                    </>
                                )
                            }

                        </div>
                    ) : (
                        <div className={styles.container_component_text}>
                            <div className={styles.component_does_not_update}>
                                {item.tipoComponente === 'titulo' && <h2>{item.conteudo || 'Título não disponível'}</h2>}
                                {item.tipoComponente === 'texto' && (

                                    <span
                                        className={styles.text}
                                        dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(item.conteudo || ''),
                                        }}
                                    />
                                )}
                                <div className={styles.buttons_edit_component}>
                                    <Button
                                        title="Editar"
                                        variant="contained"
                                        onClick={() => handleChangeEditComponent(item.id)}
                                    >
                                        <EditTwoToneIcon />
                                    </Button>
                                    <ButtonOpenModalDeleteComponent
                                        handleDeleteComponent={handleDeleteComponent}
                                        id_component={item.id}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )
            }
            <div className={styles.divider}></div>
        </form >
    );
}
